import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const MainSection = ({
  children,
  sideMenuOpen,
  drawerWidth,
  collapsedDrawerWidth,
  navbarHeight,
}) => {
  const lang = useSelector((state) => state.locale.lang);

  const customStyle = {
    backgroundColor: "#f6f6f6",
    mt: "92px",
    flexGrow: 1,
    p: {
      xs: 2,
      md: 4,
      lg: 5,
    },
    pt: {
      xs: 4,
      md: 5,
    },
    transition: (theme) =>
      theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    width: {
      xs: "100%",
      sm: `calc(100% - ${collapsedDrawerWidth}px)`,
    },
    minHeight: `calc(100vh - ${navbarHeight}px)`,
    height: "fit-content",
    ml: { sm: lang === "en" && `${collapsedDrawerWidth}px` },
    mr: { sm: lang === "ar" && `${collapsedDrawerWidth}px` },
    ...(sideMenuOpen && {
      ml: { sm: lang === "en" && `${drawerWidth}px` },
      mr: { sm: lang === "ar" && `${drawerWidth}px` },
      width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
      transition: (theme) =>
        theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
    }),
  };
  return (
    <Box component="main" sx={customStyle}>
      {children}
    </Box>
  );
};

MainSection.propTypes = {
  sideMenuOpen: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  collapsedDrawerWidth: PropTypes.number.isRequired,
  navbarHeight: PropTypes.number,
  children: PropTypes.element,
};

export default MainSection;
